import { useMemo, useState } from 'react';
import type { UserCourse } from '@teachur/http-client';

export const useCourseSelection = (courses: UserCourse[]) => {
  const [selectedIds, setSelectedIds] = useState<Set<number>>(new Set());

  const selectedCourses = useMemo(
    () => courses.filter((course) => selectedIds.has(course.id)),
    [courses, selectedIds]
  );

  const isAllSelected = courses.length > 0 && selectedIds.size === courses.length;

  const isIndeterminate = selectedIds.size > 0 && selectedIds.size < courses.length;

  const toggleSelect = (id: number) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);

      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }

      return next;
    });
  };

  const selectAll = () => {
    setSelectedIds(isAllSelected ? new Set() : new Set(courses.map((course) => course.id)));
  };

  const clearSelection = () => {
    setSelectedIds(new Set());
  };

  return {
    selectedIds,
    selectedCourses,
    selectedCount: selectedIds.size,
    isAllSelected,
    isIndeterminate,
    toggleSelect,
    selectAll,
    clearSelection,
  };
};
